import { Button, Form, Input, Modal, Space } from "antd";
import { useForm } from "antd/es/form/Form";
import { useEffect, useState } from "react";
import { updateDico } from "../../../../api/Update";
import TextArea from "antd/es/input/TextArea";
import { dicoGPT } from "../../../../api/Post";

const DicoModal = (props) => {
  const { isOpen, onClose, dicoData, markAsDico } = props;

  const [form] = useForm();

  const [definition, setDefinition] = useState("");
  const [word, setWord] = useState("");
  const [id, setId] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    form.resetFields();
    setWord(dicoData.word);
    setDefinition(dicoData.definition);
    setId(dicoData.id);
    form.setFieldsValue({
      word: dicoData.word,
      definition: dicoData.definition,
      id: dicoData.id,
    });
  }, [dicoData, form]);

  const onFinish = async () => {
    setIsLoading(true);
    const res = await updateDico({
      definition,
      word,
      ...(dicoData.id && dicoData.id !== null && { id: dicoData.id }),
    });

    markAsDico(res);
    onClose();
    setIsLoading(false);
  };

  const suggestGPT = async () => {
    setIsLoading(true);

    const res = await dicoGPT(word, dicoData.context);

    form.setFieldsValue({
      definition: res.definition,
    });
    setDefinition(res.definition);
    setIsLoading(false);
  };

  return (
    <Modal
      title={`Créer le dico : ${word}`}
      open={isOpen}
      onOk={onClose}
      onCancel={onClose}
      footer={[
        <Button type="link" loading={isLoading} key="gpt" onClick={suggestGPT}>
          Suggestion GPT
        </Button>,
        <Button loading={isLoading} key="back" onClick={onClose}>
          Annuler
        </Button>,
        <Button
          type="primary"
          loading={isLoading}
          key="submit"
          onClick={() => {
            form.submit();
          }}
        >
          Valider
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Space align="baseline">
          <Form.Item label="ID" name="id">
            <Input disabled value={id} />
          </Form.Item>
          <Form.Item
            label="Mot à définir"
            name="word"
            rules={[{ required: true, message: "Le mot est obligatoire" }]}
          >
            <Input value={word} onChange={(e) => setWord(e.target.value)} />
          </Form.Item>
        </Space>
        <Form.Item
          label="Définition"
          name="definition"
          rules={[{ required: true, message: "La définition est obligatoire" }]}
        >
          <TextArea
            value={definition}
            onChange={(e) => setDefinition(e.target.value)}
            autoSize={{ minRows: 3, maxRows: 5 }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default DicoModal;
